import { Grid, Skeleton } from "@mantine/core";
import Text from "@/components/atoms/Text";
import React from "react";
import Stack from "@/components/atoms/Stack";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

interface DetailRowProps {
  label: string;
  value: string | number | React.ReactNode | null;
  subValue?: string | React.ReactNode;
  isLoading?: boolean;
}

export const DetailRow: React.FC<DetailRowProps> = ({ label, value, subValue, isLoading }) => {
  const isMobile = useMediaQuery(`(max-width: 620px)`);
  const { t } = useTranslation();
  return (
    <>
      <Grid.Col span={3}>
        <Text size="sm" c="dimmed">
          {t(label)}
        </Text>
      </Grid.Col>
      <Grid.Col span={9}>
        <Stack align={isMobile ? "flex-end" : "flex-start"} w={"100%"} gap={0}>
          {isLoading ? (
            <Skeleton height={16} radius="sm" />
          ) : (
            <Text maw={300} size="sm" truncate={true}>
              {value ? value : t("common:unspecified")}
            </Text>
          )}
          <Text size="sm" c="dimmed">
            {subValue}
          </Text>
        </Stack>
      </Grid.Col>
    </>
  );
};

export default DetailRow;
